import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { BsThreeDots } from "react-icons/bs";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import Loader from "../../commonComponent/Loader";
import { useCareTeamContext } from "../../Context/CareTeamContext";
import {
  deleteCareTeam,
  getCareTeams,
  getCareTeamsforAdmin,
  updateCareTeamRequest,
} from "../../services/CareTeam";
import { FiEdit, FiEye, FiTrash } from "react-icons/fi";
import DeleteModal from "../../commonComponent/DeleteModal";
import { showToastError, showToastSuccess } from "../../Utils/Helper";
import AssignGrouptoCareTeam from "./AssignGrouptoCareTeam";
import AssignProgramtoCareTeam from "./AssignProgramtoCareTeam";
import { useAuth } from "../../Context/AuthContext";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import Popup from "../../commonComponent/Popup";
import { emptyListText } from "../../Utils/AllConstant";
import { ReactComponent as NoData } from "../../svg/NoAnyData.svg";

const Teams = ({ searchTerm }) => {
  const { isAdmin } = useAuth();
  const navigate = useNavigate();
  const providerId = JSON.parse(localStorage.getItem("user_id"));
  const [status, setStatus] = useState(null);
  const [filterdata, setFilterData] = useState([]);
  const {
    allTeams,
    isLoading,
    setAllTeams,
    setEditData,
    setCreateModalOpen,
    createModalOpen,
  } = useCareTeamContext();
  const [selectedTeam, setSelectedTeam] = useState({});
  const [modalOpen, setModalOpen] = useState(false); // Track modal open state
  const [teamId, setTeamId] = useState();

  useEffect(() => {
    setFilterData(allTeams); // eslint-disable-next-line
  }, [allTeams.length]);

  const getAllCareTeamsNew = async () => {
    try {
      const response = isAdmin
        ? await getCareTeamsforAdmin()
        : await getCareTeams();
      if (response.status !== 200) {
        setFilterData([]);
        return [];
      }
      setFilterData(response?.data?.data);
      setAllTeams(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleRejoin = async (id, status) => {
    try {
      let payload = {
        token: localStorage.getItem("token"),
        careTeamId: id,
        status: status,
      };
      console.log(payload, "rejoin payload");
      const response = await updateCareTeamRequest(payload);

      if (response.status !== 200) {
        showToastError("Something went wrong");
        return;
      }
      showToastSuccess("Team request rejoin");
      setStatus();
      getAllCareTeamsNew();
    } catch (error) {
      console.log(error);
    }
  };
  const handleChangeStatus = async (id, status) => {
    try {
      let payload = {
        careTeamId: id,
        status: status,
      };
      const response = await updateCareTeamRequest(payload);

      if (response.status !== 200) {
        showToastError("Something went wrong");
        return;
      }
      showToastSuccess(
        status === "accept" ? "Team request accepted" : "Team request decline"
      );
      getAllCareTeamsNew();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    onSearch(searchTerm); // eslint-disable-next-line
  }, [searchTerm]);

  useEffect(() => {
    if (!createModalOpen) {
      getAllCareTeamsNew();
      setEditData();
    } // eslint-disable-next-line
  }, [createModalOpen]);

  useEffect(() => {
    if (!modalOpen) {
      getAllCareTeamsNew();
      setTeamId();
      setSelectedTeam({});
    } // eslint-disable-next-line
  }, [modalOpen]);

  const onSearch = async (searchTerm) => {
    let searchWord = searchTerm;
    const result = allTeams.filter((value) => {
      if (value) {
        return value?.teamName
          ?.toLowerCase()
          ?.includes(searchWord?.toLowerCase());
      }
      return false;
    });

    if (searchWord === "") {
      setFilterData(allTeams);
      // getGroupLists(searchWord);
    } else {
      setFilterData(result);
    }
  };

  const handleView = async (id) => {
    const result = await getSelectedCareTeam(id);
    if (result)
      navigate("/viewcareteamnew", { state: { TeamData: result[0] } });
  };

  const deletePost = async (teamId) => {
    try {
      const response = await deleteCareTeam(teamId);
      if (response.status === 200) {
        showToastSuccess(response?.data || "Care team deleted successfully.");
        getAllCareTeamsNew();
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      showToastError(
        error?.data?.data || error.data?.message || "Some error occurred"
      );
    }
  };

  const getSelectedCareTeam = async (id) => {
    try {
      const response = await getCareTeamsforAdmin(id);
      if (response.status !== 200) {
        return;
      }
      setSelectedTeam(response?.data?.data);
      return response?.data?.data;
    } catch (error) {
      console.log(error);
    }
  };

  const isListArray = allTeams?.filter(
    (team) =>
      team?.teamMeambers?.some(
        (member) => member._id === providerId && member.status === "accept"
      ) || team.docId === providerId
  );

  const isRequestArray = allTeams?.filter((team) =>
    team?.teamMeambers?.some(
      (member) =>
        (member._id === providerId && member.status === "") ||
        (member._id === providerId && member.status === "decline")
    )
  );

  const renderList = (Teams) => {
    let filteredArr = Teams?.filter((team) => {
      return (
        team?.teamMeambers.some(
          (member) => member._id === providerId && member.status === "accept"
        ) || team.docId === providerId
      );
    });
    const result = (isAdmin ? Teams : filteredArr).map((team) => {
      return (
        <tr className="" key={team?._id}>
          <td className="text-muted">{team?.teamName}</td>
          <td className="text-muted">{team?.teamManagerName}</td>
          <td className="text-muted">{team?.groups?.length}</td>
          <td className="text-muted">{team?.programs?.length}</td>
          <td className={`${team?.status ? "text-success" : "text-danger"}`}>
            {team?.status ? "Active" : "Inactive"}
          </td>
          <td
            className="text-muted fw-bold text-left overflow-visible"
            style={{ cursor: "pointer" }}
          >
            <div className="d-flex align-items-center gap-2">
              {/* <button
                className="btn btn-light"
                onClick={() => handleView(team._id)}
              >
                <FiEye />
              </button> */}
              {(isAdmin ||
                team.teamManager === providerId ||
                team.docId === providerId) && (
                <>
                  <button
                    data-bs-toggle="modal"
                    data-bs-target="#createviewteam"
                    className="btn btn-light"
                    onClick={() => {
                      setCreateModalOpen(true);
                      setEditData(team);
                    }}
                  >
                    <FiEdit />
                  </button>
                  <button
                    className="btn btn-light"
                    data-bs-toggle="modal"
                    data-bs-target="#deletecareteam"
                    onClick={() => setTeamId(team?._id)}
                  >
                    <FiTrash />
                  </button>
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="light"
                      className="custom"
                      id="dropdown-basic"
                    >
                      <BsThreeDots className="icon" />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item
                        data-bs-toggle={"modal"}
                        data-bs-target={"#assigngroupproviders"}
                        onClick={() => {
                          setModalOpen(true);
                          setTeamId(team?._id);
                          setSelectedTeam(team);
                        }}
                      >
                        Assign to Group
                      </Dropdown.Item>
                      <Dropdown.Item
                        data-bs-toggle={"modal"}
                        data-bs-target={"#assignprogramproviders"}
                        onClick={() => {
                          setModalOpen(true);
                          setTeamId(team?._id);
                          setSelectedTeam(team);
                        }}
                      >
                        Assign to Program
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </>
              )}
            </div>
          </td>
        </tr>
      );
    });

    return result;
  };

  const renderRequestList = (Teams) => {
    const filteredArr = Teams?.filter((team) =>
      team.teamMeambers?.some(
        (member) => member._id === providerId && member.status !== "accept"
      )
    );
    const result = filteredArr?.map((team) => {
      return (
        <tr className="py-2" key={team?._id}>
          <td className="text-muted col-md-9">{team?.teamName}</td>
          <td
            className="text-muted fw-bold text-left overflow-visible"
            style={{ cursor: "pointer" }}
          >
            <div className="d-flex align-items-center gap-2">
              {team?.teamMeambers?.filter(
                (member) =>
                  member._id === providerId && member.status === "decline"
              )?.length > 0 && (
                <button
                  className="btn btn-light"
                  onClick={() => setStatus(team._id)}
                >
                  <FiEye />
                </button>
              )}
              {team?.teamMeambers?.filter(
                (member) => member._id === providerId && member.status === ""
              )?.length > 0 && (
                <>
                  <button
                    className="btn btn-success"
                    onClick={() => handleChangeStatus(team._id, "accept")}
                  >
                    Accept
                  </button>
                  <button
                    className="btn btn-danger"
                    onClick={() => handleChangeStatus(team._id, "decline")}
                  >
                    Decline
                  </button>
                </>
              )}
            </div>
          </td>
        </tr>
      );
    });

    return result;
  };

  return (
    <>
      <div className="mt-2">
        <button
          className="py-2 px-3 border-0 d-flex justify-content-center align-items-center gap-1"
          data-bs-toggle="modal"
          data-bs-target="#createviewteam"
          style={{
            backgroundColor: "rgba(31, 126, 120, 1)",
            color: "white",
            boxShadow: "4px 4px 40px 0px rgba(0, 0, 0, 0.2)",
          }}
          onClick={() => setCreateModalOpen(true)}
        >
          <AiOutlinePlusCircle size={"20px"} /> Create teams
        </button>

        <Tabs className="mt-2">
          <TabList>
            <Tab>
              <span className="resFont">My Care Teams</span>
            </Tab>
            <Tab>
              <span className="resFont">Care Team Requests</span>
            </Tab>
          </TabList>
          <TabPanel>
            {isLoading ? (
              <Loader
                mainStyle={{ height: "500px" }}
                mainClassName={""}
                visible={isLoading}
              />
            ) : allTeams?.length > 0 ? (
              <div
                style={{ height: "500px" }}
                className="overflow-y-scroll Dash"
              >
                {isListArray?.length > 0 || isAdmin ? (
                  <table
                    class="table table-hover"
                    style={{ marginTop: "0px", maxHeight: "500px" }}
                  >
                    <thead>
                      <tr>
                        <td className="py-4">Name</td>
                        <td className="py-4">Manager</td>
                        <td className="py-4">Groups</td>
                        <td className="py-4">Programs</td>
                        <td className="py-4">Status</td>
                        <td className="py-4">Action</td>
                      </tr>
                    </thead>
                    <tbody>{renderList(filterdata)}</tbody>
                  </table>
                ) : (
                  <Loader emptyTextKey={emptyListText.noAnyRequests} />
                )}
              </div>
            ) : (
              <div className="d-flex justify-content-center my-5 position-relative ">
                <p
                  className="w-50 text-center fw-bold "
                  style={{ color: "rgba(31, 126, 120, 1)", lineHeight: "30px" }}
                >
                  Hi before you get started on creating teams, you need
                  providers in your practice. Click on the button above to start
                  or{" "}
                  <span
                    data-bs-toggle="modal"
                    data-bs-target="#createviewteam"
                    className="text-decoration-underline pointer"
                    style={{ color: "rgba(31, 126, 120, 1)" }}
                  >
                    here
                  </span>
                  .
                </p>
              </div>
            )}
          </TabPanel>
          <TabPanel>
            {isLoading ? (
              <Loader
                mainStyle={{ height: "500px" }}
                mainClassName={""}
                visible={isLoading}
              />
            ) : (
              allTeams?.length > 0 && (
                <div
                  style={{ height: "500px" }}
                  className="overflow-y-scroll Dash"
                >
                  {isRequestArray?.length > 0 ? (
                    <table
                      class="table table-hover"
                      style={{ marginTop: "0px", maxHeight: "500px" }}
                    >
                      <thead>
                        <tr>
                          <td className="py-4">Team Request</td>
                          <td className="py-4">Action</td>
                        </tr>
                      </thead>
                      <tbody>{renderRequestList(filterdata)}</tbody>
                    </table>
                  ) : (
                    <>
                      <Loader
                        mainStyle={{ height: "500px" }}
                        visible={false}
                        noAnyData={!(isRequestArray?.length > 0)}
                      />
                    </>
                  )}
                </div>
              )
            )}
            <Popup
              show={status}
              onHide={() => setStatus(null)}
              title={"Rejoin"}
              modalId={"status"}
              content={<h3 className="text-center">Invitation sent!</h3>}
              position={"left"}
              btn1={"yes"}
              btn2={"no"}
              onClickBtn1={() => handleRejoin(status, "rejoin")}
            />{" "}
          </TabPanel>
        </Tabs>
      </div>
      <DeleteModal
        title={"Delete"}
        content1={"Are you sure you want to delete"}
        content2={"this question?"}
        modalId={"deletecareteam"}
        button2={"No"}
        button1={"Yes"}
        onDelete={() => deletePost(teamId)}
      />
      <AssignGrouptoCareTeam
        selectedTeam={selectedTeam}
        members={teamId}
        getAllProviders={getAllCareTeamsNew}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
      />
      <AssignProgramtoCareTeam
        selectedTeam={selectedTeam}
        members={teamId}
        getAllProviders={getAllCareTeamsNew}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
      />
    </>
  );
};

export default Teams;
